import { Injectable, Pipe, PipeTransform } from '@angular/core';

import { ConfigService } from './config.service';

@Injectable()
@Pipe({
  name: 'config',
  standalone: false,
})
export class ConfigPipe implements PipeTransform {
  constructor(private readonly config: ConfigService) {}

  // eslint-disable-next-line
  public transform(value: string | Array<string>): any {
    return this.config.getSettings(value);
  }
}
